// extracted by mini-css-extract-plugin
export default {"failedProcessStepDialog":"failedProcessStepDialog-labhu","narrow":"narrow-nVyx2"};